import request from '@/utils/request';

export function doPay(data) {
	return request({
		url: 'pay/dopay',
		method: 'post',
		data,
	});
}

export function getUserInte() {
	return request({
		url: 'pay/inte',
		method: 'get',
		is_cancel_require: true,
	});
}

export function getSurplusApi () {
	return request({
		url: 'pay/surplus',
		method: 'get',
		// is_cancel_require: true,
	})
}

export function getSurplusiogApi (data) {
		return request({
			url: 'pay/get-surplus-log',
			method: 'get',
			params: data
		});
}
	
export function getinteiog() {
	return request({
		url: 'pay/get-inte-log',
		method: 'get'
	});
}

export function getMoviePayInfoApi(data) {
	return request({
		url: '/pay/get-movie-pay-info',
		method: 'post',
		data
	});
}

export function moviePayApi(data) {
	return request({
		url: '/pay/movie-pay',
		method: 'post',
		data
	});
}
